import React, { Component } from "react";
import { Col, Row, Form, Button } from "react-bootstrap";
import Pagination from "../Pagination/Pagination";
import classes from "./scheduleInterviewer.module.css";
import { NavLink } from "react-router-dom";
import Modal from "../feedback/feedback";
import Nodataerror from "../commonComponents/NetworkError/NodataError/Nodataerror";
import Servererror from "../commonComponents/NetworkError/ServerError/Servererror";
import add from "../../Assets/icons/1.5x/Addhdpi.png";
import { connect } from "react-redux";
import * as actionTypes from "../../Action/Index";
import Loader from "react-loader-advanced";
import Spinner from "react-bootstrap/Spinner";
import Modeofinterview from "../extInterviewSchedule/Modeofinterview";
import labels from "../../Labels/Label";
import moment from "moment";
import { async } from "q";
import loading from "../../Assets/Images/loader-green.gif";
import ConfirmAlert from "../commonComponents/ConfirmSweetAlert";
import SweetAlert from "../commonComponents/SweetAlert";
import NewSweetAlert from "react-bootstrap-sweetalert";
import FeedbackModal from "../feedback/feedback";

import ReactStars from "react-stars";
import star from "../../Assets/icons/1x/rating starmdpi.png";
import ViewinterviewDetailModal from "./ViewinterviewDetails";
class scheduleInterview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModeofinterviewModal: false,
    };
    // let base64Url = localStorage.getItem('userToken').split('.')[1];
    // let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    // let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
    //     return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    // }).join(''));

    this.state = {
      show: false,
      rateshow: false,
      arrayList: null,
      currentPage: 1,
      id: "",
      showCancelInterviewModal: false,

      reasonBlock: false,
      reasonText: "",
      interviewid: null,
      interviewerEmail: "",

      remainingBalance: 0,
      interviewBalanceSuffient: false,
      checkBalanceError: false,
      showInsufficientBalance: false,
      // isAdmin:JSON.parse(jsonPayload).AUTHORITIES_KEY,
      viewInterview: false,
      interviewDate: null,
      userType: localStorage.getItem("userType"),
    };
  }
  showInterviewDetails = (id, date) => {
    this.setState({
      viewInterview: !this.state.viewInterview,
      interviewid: id,
      interviewDate: date,
    });
  };

  cancelHandler = () => {
    this.setState({
      showCancelInterviewModal: false,
    });
  };

  handleModeOfInterviewModal = () => {
    this.setState({
      showModeofinterviewModal: !this.state.showModeofinterviewModal,
    });
  };
  nextAction = () => {
    this.setState({
      showCancelInterviewModal: false,
    });
    this.props.employerCancelInterview(
      this.state.interviewid,
      "Candidate is not available",
      this.state.currentPage
    );
  };

  handleModal = () => {
    this.setState({
      show: !this.state.show,
    });
  };

  setIdForFeedback = (id) => {
    this.setState({
      id: id,
    });
  };
  onPageChange = (id) => {
    this.setState(
      {
        currentPage: id,
      },
      () => {
        this.props.scheduleInterviewList(this.state.currentPage);
      }
    );
  };
  onLeftChange = () => {
    if (this.state.currentPage === 1) {
      return;
    }
    this.setState(
      {
        currentPage: this.state.currentPage - 1,
      },
      () => {
        this.props.scheduleInterviewList(this.state.currentPage);
      }
    );
  };
  onRightChange = () => {
    if (
      this.props.paginationData.totalNumberOfPagesAsPerGivenPageLimit ===
      this.state.currentPage
    ) {
      return;
    }
    this.setState(
      {
        currentPage: this.state.currentPage + 1,
      },
      () => {
        this.props.scheduleInterviewList(this.state.currentPage);
      }
    );
  };

  componentDidMount = () => {
    this.props.scheduleInterviewList(this.state.currentPage);
    this.props.getCreditBalance();
  };

  // componentWillReceiveProps(nextProps)
  // {
  //     if(nextProps.interviewArray!==null)
  //     {
  //         this.setState({arrayList:nextProps.interviewArray})
  //     }
  //     if(nextProps.remainingBalance !== null)
  //     {
  //         this.setState({remainingBalance:nextProps.remainingBalance,interviewBalanceSuffient:nextProps.sufficientBalance})
  //     }
  // }
  // dateFunction=(str)=>{
  //     var ds = str;
  //     var date = moment(new Date(ds.substr(0, 16)));
  //     return (date.format("DD-MMM-YYYY"));
  //    }

  hideAlert = () => {
    this.setState({
      reasonBlock: false,
    });
  };

  //     rate_handleClose = () => {
  //         this.setState({rateshow:false})
  //     };
  //     rate_handleShow = (id,email) =>  {

  //        this.setState({rateshow:true,interviewid:id,interviewerEmail:"abc.def@innovationm.com"})

  //    };
  //    redirectPage = () => {
  //        this.setState({showInsufficientBalance:false,})

  // }

  // parseJwt () {
  //     var base64Url = localStorage.getItem('userToken').split('.')[1];
  //     var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  //     var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
  //         return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  //     }).join(''));

  //     return JSON.parse(jsonPayload);
  //   }

  render() {
    let list = "";

    if (this.props.interviewArray !== null) {
      list = this.props.interviewArray.map((index) => {
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        //let current_datetime = new Date(index.interviewDate)
        let current_datetime = new Date(index.interviewDate / 1000);
        let formatted_date =
          current_datetime.getDate() +
          " " +
          months[current_datetime.getMonth()];

        var timeobject = new Date(index.startTime / 1000);
        //var timeobject = new Date(index.startTime);

        var hourstart = moment(timeobject).utc().format("hh:mm A");

        let text = "";
        if (index.isinterviewCancelled === false) {
          if (index.feedbackPresent === false) {
            text = (
              <Button
                style={{
                  padding: "2px 10px 2px 10px",
                  fontWeight: "600",
                  fontFamily: "Nunito",
                  borderRadius: "20px",
                }}
                variant="warning"
                onClick={() =>
                  this.setState({
                    showCancelInterviewModal: true,
                    interviewid: index.id,
                  })
                }
              >
                Cancel
              </Button>
            );
          }
          // else{
          //        if(index.rating==null || index.rating==0)
          //           text = <Button style={{padding: '1px 8px 1px 8px'}} variant = "warning" onClick={()=>this.rate_handleShow(index.id)}>Rate</Button>
          //        else
          //           text=<span>{index.rating} <img type="image/svg+xml" src={star} style={{marginBottom:'4px'}}/></span>

          // }
        } else if (index.isinterviewCancelled === true) {
          if (index.cancellingPerson === "INTERVIEWER") {
            text = (
              <span
                style={{
                  textDecoration: "underline",
                  color: "#fbb03b",
                  cursor: "pointer",
                }}
                onClick={() =>
                  this.setState({
                    reasonBlock: true,
                    reasonText: index.interviewCancellationReason,
                  })
                }
              >
                Reason
              </span>
            );
          }
        }

        return (
          <tr key={index.id} style={{ height: "41px" }}>
            <td
              onClick={() =>
                this.showInterviewDetails(index.id, index.interviewDate)
              }
              style={{
                cursor: "pointer",
                maxWidth: "15vw",
                minWidth: "15vw",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                paddingRight: "30px",
              }}
            >
              &nbsp;&nbsp;{index.interviewerName}
            </td>

            {/* <td onClick={()=>this.showInterviewDetails(index.id,index.interviewDate)} style={{cursor:"pointer"}}>{index.interviewerName}</td> */}

            <td
              onClick={() =>
                this.showInterviewDetails(index.id, index.interviewDate)
              }
              style={{ cursor: "pointer" }}
            >
              {formatted_date}, {hourstart}
            </td>

            {/* {index.interviewStatus==="CONFIRMED"?(index.feedbackPresent===true?<td><a className={classes.desginColor} href="javascript:void(0)"

                  onClick={() => {this.setIdForFeedback(index.id); this.handleModal()}}>View</a></td>
                  
                  :<td>Pending</td>):<td>-</td>}
                     <td>{index.isinterviewCancelled ? index.cancellingPerson === "INTERVIEWER" ? 'CANCELLED':index.interviewStatus: index.interviewStatus}</td> */}

            {index.isinterviewCancelled ? (
              index.cancellingPerson === "INTERVIEWER" ? (
                <>
                  <td>CANCELLED</td>
                  <td style={{ minWidth: "5vw", maxWidth: "5vw" }}>{text}</td>
                </>
              ) : (
                <>
                  <td>Cancelled</td>
                  <td style={{ minWidth: "5vw", maxWidth: "5vw" }}></td>
                </>
              )
            ) : index.interviewStatus === "CONFIRMED" ? (
              index.feedbackPresent === true ? (
                <>
                  <td>
                    <a
                      className={classes.desginColor}
                      href="javascript:void(0)"
                      onClick={() => {
                        this.setIdForFeedback(index.id);
                        this.handleModal();
                      }}
                    >
                      Feedback
                    </a>
                  </td>
                  <td style={{ minWidth: "5vw", maxWidth: "5vw" }}>{text}</td>
                </>
              ) : (
                <>
                  <td>Scheduled</td>{" "}
                  <td style={{ minWidth: "5vw", maxWidth: "5vw" }}>{text}</td>
                </>
              )
            ) : (
              <>
                {index.interviewStatus == "DECLINED" ? (
                  <>
                    <td style={{ minWidth: "5vw", maxWidth: "5vw" }}>
                      INVITE {index.interviewStatus}
                    </td>
                    <td style={{ minWidth: "5vw", maxWidth: "5vw" }}></td>
                  </>
                ) : (
                  <>
                    <td style={{ minWidth: "5vw", maxWidth: "5vw" }}>
                      INVITE {index.interviewStatus}
                    </td>{" "}
                    <td style={{ minWidth: "5vw", maxWidth: "5vw" }}>{text}</td>
                  </>
                )}
              </>
            )}
          </tr>
        );
      });
    }

    return (
      <div>
        <FeedbackModal
          show={this.state.show}
          id={this.state.id}
          handleClose={this.handleModal}
        />
        <Row>
          <Col md={12}>
            {this.state.userType == 0 ? (
              <div className={classes.heading}>
                <h3>{labels.counsellorHeading}</h3>
              </div>
            ) : (
              <div className={classes.heading}>
                <h3>{labels.interviewHeading}</h3>
              </div>
            )}
          </Col>
        </Row>
        <Loader
          show={this.props.loader}
          message={<img src={loading} />}
          style={{ height: "auto" }}
          foregroundStyle={{ color: "#00a99d" }}
          backgroundStyle={{ backgroundColor: "#F3EFEF" }}
        >
          <Row className={`${classes.gapTop}`}>
            <Col md={12} className={classes.topRow}>
              <Form className="form-inline">
                {/* <NavLink to="/interview/createNew"> */}
                {this.state.userType == 0 ? (
                  <Button
                    type="button"
                    variant="warning"
                    className={classes.searchButton}
                    onClick={this.handleModeOfInterviewModal}
                  >
                    <img
                      type="image/svg+xml"
                      src={add}
                      style={{ marginRight: "10px" }}
                      width="25px"
                    />{" "}
                    {labels.counsellorBtn}
                  </Button>
                ) : (
                  <Button
                    type="button"
                    variant="warning"
                    className={classes.searchButton}
                  >
                    <img
                      type="image/svg+xml"
                      src={add}
                      style={{ marginRight: "10px" }}
                      width="25px"
                    />{" "}
                    {labels.selfAssessmentBtn}
                  </Button>
                )}
                {/* </NavLink> */}
              </Form>
              <Modeofinterview
                show={this.state.showModeofinterviewModal}
                handleJobProfilePage={this.handleJobProfilePage}
                ShowModalClose={this.ShowModalClose}
              />
              {/* <div className={classes.credits}>
                <span>Credit: &#8377; {this.props.creditBalance}</span>
              </div> */}
              <div className="scheduleInterviewer_credits__1QHRD">
                <div className={classes.credits}>
                  <span style={{ marginLeft: "16rem" }}>
                    Credit: &#8377; {this.props.creditBalance}
                  </span>
                </div>
                {this.props.creditBalance < 0 ? (
                  <p style={{ fontSize: "14px" }}>
                    Please contact <a href="tel:+917007965311">+917007965311</a>{" "}
                    /{" "}
                    <a href="mailto:support@foxmatrix.com">
                      support@foxmatrix.com
                    </a>{" "}
                    to add credits
                  </p>
                ) : (
                  this.props.userType == 0 && (
                    <div className={classes.credits}>
                      <span>Credit: &#8377; {this.props.creditBalance}</span>
                    </div>
                  )
                )}

                <p></p>
              </div>
            </Col>
          </Row>
          <br />
          {this.props.interviewArray &&
            this.props.interviewArray.length > 0 && (
              <Row>
                <Col
                  md={12}
                  className="table-responsive"
                  style={{ height: "60vh" }}
                >
                  <table
                    className={classes.scheduleInterviewTbl}
                    style={{
                      borderCollapse: "separate",
                      borderSpacing: "0px 0px",
                    }}
                  >
                    <thead>
                      <tr>
                        {this.state.userType == 0 ? (
                          <th>&nbsp;&nbsp;{labels.counsellorTable}</th>
                        ) : (
                          <th>&nbsp;&nbsp;{labels.interviewTable}</th>
                        )}
                        {/* <th>Interviewer</th> */}
                        <th>Date & Timing</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>{list}</tbody>
                  </table>
                </Col>
              </Row>
            )}
          {
            // this.props.interviewArray &&
            this.props.errorMsg ===
              "List of Scheduled interviews will show up here" && (
              <Nodataerror
                msg="Nothing Scheduled"
                marginTop="10%"
                width="20%"
              />
            )
          }
          {/* {this.props.getInterviewListNetworkStatus===false?<>
                {this.props.getApiStatus===true && this.props.interviewArray!==null && this.props.interviewArray!=="" && this.props.interviewArray!==undefined && this.props.interviewArray.length!==0?<>
            <Row>
                <Col md={12} className="table-responsive">
                    <table className={classes.scheduleInterviewTbl}>
                        <thead>
                            <tr>
                            <th>Position</th>
                            <th>Interviewer</th>
                            <th>Interview Date & Timing</th>
                            <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list}                             
                          </tbody>
                        
                    </table>
                </Col>
            </Row>
                <Row>
                    <Col md={12}>
                    {this.props.paginationData.totalNumberOfPagesAsPerGivenPageLimit>1?<Pagination 
                        activePage={this.state.currentPage}
                        pageRangeDisplayed={this.props.paginationData.totalNumberOfPagesAsPerGivenPageLimit}
                        onPageChange={this.onPageChange}
                        onLeftChange={this.onLeftChange}
                        onRightChange={this.onRightChange}
                    />:null}
                    
                    </Col>
                   
                </Row> 
                 </>:<Nodataerror msg={this.props.errorMsg} marginTop="10%" width="20%"/>}
                </>:<Servererror msg={this.props.errorMsg}  width="20%"/>} */}
        </Loader>
        {/* <Modal 
            show={this.state.show}
            handleClose={this.handleModal}
            id= {this.state.id}
            /> */}
        {/*           
          {this.state.viewInterview?
           <ViewinterviewDetailModal
             show={this.state.viewInterview}
             onHide={this.showInterviewDetails}
             interviewid={this.state.interviewid}
             interviewDate={this.state.interviewDate}
           />:null} */}

        {this.state.showCancelInterviewModal ? (
          <ConfirmAlert
            show="true"
            nextAction={this.nextAction}
            cancelHandler={this.cancelHandler}
            msg="Are you sure you want to cancel ?"
            msg2="You can't undo this action."
          />
        ) : null}
        {this.props.cancelInterviewError ? (
          <SweetAlert
            show="true"
            type="danger"
            msg={this.props.cancelInterviewErrorMessage}
          />
        ) : null}
        {this.props.cancelInterviewSuccess ? (
          <SweetAlert
            show="true"
            type="success"
            msg="Cancelled Successfully!"
          />
        ) : null}
        {this.state.reasonBlock ? (
          <NewSweetAlert
            style={{ width: "400px", marginLeft: "-210px", padding: "3px" }}
            title={
              <h3 style={{ color: "#fbb03b", marginTop: "10px" }}>Reason</h3>
            }
            onConfirm={this.hideAlert}
            confirmBtnBsStyle="none"
            confirmBtnCssClass={classes.confirmButtonStyle}
          >
            <div
              style={{
                border: "1px solid grey",
                textAlign: "justify",
                marginTop: "4.5%",
                marginBottom: "5%",
                borderRadius: "5px",
                padding: "3px",
                width: "84%",
                marginLeft: "8%",
                minHeight: "90px",
              }}
            >
              {this.state.reasonText}
            </div>
          </NewSweetAlert>
        ) : null}
        {/* <Row>
                    <Col md={12}> */}
        {this.props.paginationData.totalNumberOfPagesAsPerGivenPageLimit > 1 ? (
          <Pagination
            style={{
              bottom: 10,
              display: "flex",
              justifyContent: "center",
              paddingLeft: 180,
            }}
            activePage={this.state.currentPage}
            pageRangeDisplayed={
              this.props.paginationData.totalNumberOfPagesAsPerGivenPageLimit
            }
            onPageChange={this.onPageChange}
            onLeftChange={this.onLeftChange}
            onRightChange={this.onRightChange}
          />
        ) : null}

        {/* </Col>
                   
                </Row>  */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getApiStatus: state.employeeReducer.getInterviewListStatus,
    interviewArray: state.employeeReducer.interviewList,
    paginationData: state.employeeReducer.pagination,
    loader: state.employeeReducer.getInterviewListLoader,
    errorMsg: state.employeeReducer.errorMsg,
    creditBalance: state.employeeReducer.creditBalance,
    //  getInterviewListNetworkStatus:state.employeeReducer.getInterviewListNetworkStatus,
    cancelInterviewError: state.employeeReducer.cancelInterviewError,
    cancelInterviewErrorMessage: state.employeeReducer.cancelInterviewErrorMsg,
    cancelInterviewSuccess: state.employeeReducer.cancelInterviewSuccess,
    //  checkBalanceError: state.employeeReducer.checkInterviewBalanceError,
    //  checkBalanceErrorMsg: state.employeeReducer.checkInterviewBalanceErrorMsg,
    //  sufficientBalance: state.employeeReducer.sufficientBalance,
    //  checkBalanceNetworkError: state.employeeReducer.checkInterviewBalanceNetworkError,
    //  remainingBalance: state.employeeReducer.remainingBalance,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    scheduleInterviewList: (id) => dispatch(actionTypes.getInterviewList(id)),
    feedBackErrorFalse: () => dispatch(actionTypes.getFeedBackErrorFalse()),
    employerCancelInterview: (interviewid, reason, page) =>
      dispatch(actionTypes.employerCancelInterview(interviewid, reason, page)),
    checkInterviewScheduleBalance: () =>
      dispatch(actionTypes.checkInterviewScheduleBalance()),
    getCreditBalance: () => dispatch(actionTypes.getCreditBalance()),
    getCandidateFeedback: (id) =>
      dispatch(actionTypes.getCandidateFeedback(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(scheduleInterview);
